import ArrowIcon from './arrow.svg';
import { cssMap } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives';

const styles = cssMap({
  flip: {
    transform: 'rotate(180deg)',
  },
});

export const Arrows = () => {
  return (
    <Stack space={'space.100'}>
      <img css={styles.flip} src={ArrowIcon} alt={''} />
      <img src={ArrowIcon} alt={''} />
    </Stack>
  );
};

export default Arrows;
